export enum AUTHENTICATION_ALERT_CODES {
  DEFAULT = 'DEFAULT',
  MFA_STEP_UP_ERROR = 'MFA_STEP_UP_ERROR',
  MFA_STEP_UP_SUCCESS = 'MFA_STEP_UP_SUCCESS',
  MFA_ENROLMENT_TOO_MANY_REQUESTS = 'MFA_ENROLMENT_TOO_MANY_REQUESTS'
}

export const AUTHENTICATION_FORM_TEST_ID = {
  MFA_STEP_UP: 'mfa-step-up',
  MFA_VERIFY_EMAIL: 'mfa-verify-email',
  PASSWORD_RESET_LINK: 'password-reset-link-form',
  PASSWORD_RESET_LINK_ALERT: 'password-reset-link-alert'
};
